import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

interface StructureStore {
  structureId: string | undefined;
  setStructureId: (data: string) => void;
}

export const useStructureStore = create<StructureStore>()(
  devtools(
    persist(
      (set) => ({
        structureId: undefined,
        setStructureId: (data) => set({ structureId: data }),
      }),
      {
        name: "structure-storage",
      }
    ),
    { name: "StructureStore" }
  )
);
